import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SocialProps } from '@/features/publicDatasets/publicdatasets/PublicDatasetsTopPanel/Social/types';
import { TrevorComponent } from '@trevor/ui-components';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPublicDatasetMetadata } from '@/store-selectors';
import Twitter from './Twitter';
import Facebook from './Facebook';
import Reddit from './Reddit';
import LinkedIn from './LinkedIn';
import CopyUrlButton from './CopyUrlButton';

const Social: TrevorComponent<SocialProps> = ({ title, className }) => {
  const { metadata, rowRequestId } = useSelector(getPublicDatasetMetadata);

  const { datasourceId, dataView } = useParams();

  const finalTitle = metadata?.title || title;

  const [shareUrl, setShareUrl] = useState('');

  useEffect(() => {
    const viewPart = dataView ? `/${dataView}` : '/edit';
    const rowsRequestPart = rowRequestId ? `/${rowRequestId}` : '';

    setShareUrl(
      `${window.origin}/publicdatasets/${datasourceId}${viewPart}${rowsRequestPart}`,
    );
  }, [datasourceId, rowRequestId, dataView]);

  return (
    <div className={className}>
      <Twitter title={finalTitle} url={shareUrl} />
      <Reddit title={finalTitle} url={shareUrl} />
      <Facebook title={finalTitle} url={shareUrl} />
      <LinkedIn title={finalTitle} url={shareUrl} />
      <CopyUrlButton url={shareUrl} />
    </div>
  );
};

export default styled(Social)`
  display: inline-flex;
  gap: 4px;
  .socialButton {
    cursor: pointer;
    width: 31px;
    height: 31px;
    margin-right: 0;
  }
`;
